import React from "react"

const Loading = (props) => (
  <div className="stylish-table__row stylish-table__row--body">
    <div className="stylish-table__cell">
      <div>
        <span style={{ display: "block ruby" }}>
          <strong>{props.bookingLoadingText}</strong>
        </span>
      </div>
    </div>
  </div>
)

export default Loading
